import api from "../services/api";
import { resolverPropiedadIdPorReferencia } from "./resolverPropiedadIdPorReferencia";
import { buildPropiedadAddress } from "../components/propiedades/BotonesVisorUbicacion";
import { finanzasFormateadasDesdePropiedad } from "./finanzasExpedientePropiedad";

function direccionDesdeProp(prop = {}) {
  const compuesta = buildPropiedadAddress(prop);
  if (compuesta) return compuesta.replace(/,?\s*España\s*$/i, "").trim();
  const partes = [prop.tipo_via, prop.nombre_via, prop.numero].filter(Boolean).map(String);
  if (partes.length) return partes.join(" ").trim();
  return String(prop.direccion || prop.direccion_completa || prop.titulo || "").trim();
}

function finanzasDesdePropiedad(prop = {}) {
  return finanzasFormateadasDesdePropiedad(prop);
}

function propiedadDesdeApiResponse(pr) {
  return pr?.data?.data ?? pr?.data ?? null;
}

/**
 * Propiedad que el cliente compró/reservó (ficha cliente → vendidas/reservado),
 * no la ref. de entrada del lead.
 */
export async function resolverPropiedadCompraCliente(clienteId, leadFallback = {}) {
  if (clienteId) {
    try {
      const r = await api.get(`/clientes/${clienteId}/propiedades-vendidas`);
      const rows = r.data?.data || [];
      if (rows.length > 0) {
        const top = rows[0];
        return {
          propiedad_id: top.propiedad_id || null,
          referencia: String(top.referencia || "").trim(),
          fuente: "cliente_vendida",
        };
      }
    } catch { /* fallback lead */ }
  }

  const ref = String(leadFallback.propiedad_ref || leadFallback.prop_referencia || "").trim();
  return {
    propiedad_id: leadFallback.propiedad_id || null,
    referencia: ref,
    fuente: "lead",
  };
}

export async function cargarPropiedadExpediente({ propiedad_id, referencia, prop_direccion, prop_poblacion, prop_provincia } = {}) {
  let prop = null;
  let propId = propiedad_id || null;
  const ref = String(referencia || "").trim();

  if (propId) {
    try {
      const pr = await api.get(`/propiedades/${propId}`);
      prop = propiedadDesdeApiResponse(pr);
    } catch { /* fallback */ }
  }
  if (!prop && ref) {
    if (!propId) propId = await resolverPropiedadIdPorReferencia(ref);
    if (propId) {
      try {
        const pr = await api.get(`/propiedades/${propId}`);
        prop = propiedadDesdeApiResponse(pr);
      } catch { /* */ }
    }
  }

  if (prop) {
    let propietarios = [];
    try {
      const ppRes = await api.get(`/propiedades/${prop.id}/propietarios`);
      propietarios = (ppRes.data?.data || []).map((pp) => ({
        contacto_id: pp.contacto_id,
        nombre: pp.nombre || "",
        apellidos: pp.apellidos || "",
        telefono: pp.telefono || "",
        email: pp.email || "",
        pleno_dominio: pp.porcentaje ?? 100,
        nuda_propiedad: "",
        usufructo: "",
      }));
    } catch { /* */ }

    const fin = finanzasDesdePropiedad(prop);

    return {
      propiedades: [{
        propiedad_id: prop.id,
        referencia: prop.referencia,
        direccion: direccionDesdeProp(prop),
        poblacion: prop.poblacion_nombre || prop.poblacion || "",
        provincia: prop.provincia || "",
        vpo: false,
      }],
      propietarios,
      ...fin,
      prop_agente_id: prop.agente_id || null,
    };
  }

  if (ref) {
    return {
      propiedades: [{
        referencia: ref,
        direccion: prop_direccion || "",
        poblacion: prop_poblacion || "",
        provincia: prop_provincia || "",
        vpo: false,
      }],
      propietarios: [],
      precio_venta: "",
      precio_propietario: "",
      honorarios: "",
      honorarios_iva: "",
      prop_agente_id: null,
    };
  }

  return null;
}
